/**
 * Match cliente-side de socios para búsquedas en grids ya cargadas.
 *
 * Replica la lógica del backend (`SocioRepository.list_by_empresa` con
 * `search`) para que la experiencia sea consistente entre el listado de
 * socios (server-side) y los grids derivados como la asistencia de
 * asamblea (client-side, donde los socios ya están en memoria).
 *
 * Reglas:
 *  - Multi-token: separa por espacios, AND entre tokens, OR entre campos.
 *  - RUT normalizado: tipear "12345678" matchea "12.345.678-9" y viceversa.
 *  - Teléfono normalizado: ignora espacios, guiones y "+".
 *  - Si el token es solo dígitos, también matchea contra `numero_socio`.
 */

export interface SocioFiltrable {
  nombre: string;
  rut: string;
  numero_socio?: number | null;
  numero_libro?: string | null;
  telefono?: string | null;
  correo?: string | null;
}

const SOLO_ALFANUM = /[\s.\-+]/g;

function norm(s: string | null | undefined): string {
  return (s ?? "").toLowerCase().replace(SOLO_ALFANUM, "");
}

function lower(s: string | null | undefined): string {
  return (s ?? "").toLowerCase();
}

export function matchSocio(s: SocioFiltrable, query: string): boolean {
  const q = query.trim();
  if (!q) return true;
  const tokens = q.split(/\s+/);

  for (const token of tokens) {
    const tLower = token.toLowerCase();
    const tNorm = norm(token);

    const hits =
      lower(s.nombre).includes(tLower) ||
      lower(s.numero_libro).includes(tLower) ||
      lower(s.correo).includes(tLower) ||
      norm(s.rut).includes(tNorm) ||
      norm(s.telefono).includes(tNorm) ||
      (/^\d+$/.test(token) &&
        s.numero_socio != null &&
        String(s.numero_socio).includes(token));

    if (!hits) return false; // todo token tiene que matchear (AND)
  }
  return true;
}
